import logo from "../assets/logos/black_logo.png";
import american from "../assets/logos/american.svg";
import master from "../assets/logos/master.svg";
import jcb from "../assets/logos/jcb.svg";
import visa from "../assets/logos/visa.svg";
import bottel_img from "../assets/logos/bottel_img.png";

export default {
  logo,
  visa,
  master,
  jcb,
  american,
  bottel_img,
};
